import { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import './index.css';

export default function LoveSPA() {
  const [opened, setOpened] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const rootRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;
    function onMove(e) {
      const rect = el.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;
      el.style.transform = `perspective(900px) rotateX(${(-y * 8).toFixed(2)}deg) rotateY(${(x * 10).toFixed(2)}deg) translateZ(0)`;
    }
    function onLeave() {
      el.style.transform = "none";
    }
    el.addEventListener("mousemove", onMove);
    el.addEventListener("mouseleave", onLeave);
    return () => {
      el.removeEventListener("mousemove", onMove);
      el.removeEventListener("mouseleave", onLeave);
    };
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let w = (canvas.width = window.innerWidth);
    let h = (canvas.height = window.innerHeight);
    let particles = [];

    function resize() {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    }
    window.addEventListener("resize", resize);

    function rand(min, max) {
      return Math.random() * (max - min) + min;
    }

    function newHeart() {
      const size = rand(6, 26);
      return {
        x: rand(0, w),
        y: h + 20,
        vx: rand(-0.6, 0.6),
        vy: rand(-2.5, -0.6),
        size,
        rotation: rand(0, Math.PI * 2),
        life: rand(120, 340),
        t: 0,
      };
    }

    for (let i = 0; i < 40; i++) particles.push(newHeart());

    let raf;
    function drawHeart(x, y, size, rotation) {
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rotation);
      ctx.beginPath();
      const topCurveHeight = size * 0.3;
      ctx.moveTo(0, topCurveHeight);
      ctx.bezierCurveTo(0, topCurveHeight - size / 2, -size, topCurveHeight - size / 2, -size, topCurveHeight);
      ctx.bezierCurveTo(-size, topCurveHeight + size / 2, 0, topCurveHeight + size, 0, topCurveHeight + size * 1.3);
      ctx.bezierCurveTo(0, topCurveHeight + size, size, topCurveHeight + size / 2, size, topCurveHeight);
      ctx.bezierCurveTo(size, topCurveHeight - size / 2, 0, topCurveHeight - size / 2, 0, topCurveHeight);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
    }

    function loop() {
      ctx.clearRect(0, 0, w, h);
      particles.forEach((p, i) => {
        p.x += p.vx;
        p.y += p.vy;
        p.vy -= 0.01 * Math.random();
        p.rotation += 0.01 * (i % 2 === 0 ? 1 : -1);
        p.t++;
        const alpha = Math.max(0, 1 - p.t / p.life);
        ctx.globalAlpha = alpha;
        const gradient = ctx.createLinearGradient(p.x - p.size, p.y - p.size, p.x + p.size, p.y + p.size);
        gradient.addColorStop(0, 'rgba(255,150,180,0.9)');
        gradient.addColorStop(1, 'rgba(255,80,120,0.9)');
        ctx.fillStyle = gradient;
        drawHeart(p.x, p.y, p.size, p.rotation);
        ctx.globalAlpha = 1;
        if (p.t > p.life || p.y < -50) particles[i] = newHeart();
      });
      raf = requestAnimationFrame(loop);
    }
    loop();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <div onClick={(e) => {
      if (!showVideo) return;
      if (e.target.tagName === 'DIV' || e.target.tagName === 'BUTTON') setShowVideo(false);
    }} className="min-h-screen bg-gradient-to-b from-pink-50 via-rose-50 to-white flex items-center justify-center overflow-hidden relative">
      <canvas ref={canvasRef} className="pointer-events-none fixed inset-0 z-0" />

      <div ref={rootRef} className="relative z-10 max-w-5xl w-full p-8">
        <div className="flex flex-col md:flex-row gap-8 items-center justify-between">

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="flex-1 flex items-center justify-center"
          >
            <div className="scene">
              <div
                className={`envelope cursor-pointer select-none ${opened ? 'open' : ''}`}
                onClick={() => setOpened(!opened)}
                aria-label="Open love envelope"
                role="button"
              >
                <div className={`envelope-body ${opened ? 'open' : ''}`}>
                  <div className={`absolute inset-0 flex items-center justify-center pointer-events-none ${opened ? 'invisible' : 'visible'}`}>
                    <span className="rounded-xl p-2 bg-rose-600 text-sm z-10 text-xl text-xs text-white">
                      Ở đây có thư nè
                    </span>
                  </div>
                  <div className={`envelope-flap ${opened ? 'open' : ''}`} />
                  <div className="letter" aria-hidden={!opened}>
                    <div className="letter-inner">
                      <h2 className="text-xl font-semibold">Gửi Trúc Phương của An,</h2>
                      <p className="mt-3 text-xs leading-relaxed">Mới đi có 1 tháng à mà anh nhớ em lắm. Đêm nào An cx ôm gối con bò ngủ ròi mơ thấy em hết.  A mơ thấy mình cãi lộn cx có, thấy a bay về cx có, thấy a chở e đi mua Viên Viên như xưa cx có.</p>
                      <p className="mt-3 text-xs leading-relaxed">Dù bên a có quá trời cảnh đẹp nhma thiếu em nên lúc nào a cũng thấy trống rỗng hết. Ngày nào cũng 1 vòng lặp: thức dậy, đi làm, đi về, chỉ có tối vid call với em anh mới thấy dui thôi á. 
Em ở VN nhớ giữ sk nha, a vẫn đặt đồ ăn đồ ún cho em được, em phải ăn ún cho hết nha đừng có bỏ mứa tui biết tui dận á! Nhớ ngủ đủ, bớt thức khuya lại, rùi T12 anh bay dìa với em</p>
                      <p className="mt-4 text-xs opacity-80">- Thương em lắm</p>
                    </div>
                  </div>
                </div>
                <div className="shine" />
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.08 }}
            className="flex-1 flex flex-col items-center gap-4"
          >
            <h1 className="text-4xl md:text-5xl font-extrabold text-rose-600 drop-shadow-sm">A Little Love</h1>

            <div className="flex gap-4 mt-4">
              <button
                onClick={() => setShowVideo(true)}
                className="
                  px-5 py-2 rounded-2xl 
                  bg-rose-600 text-white 
                  font-medium shadow-2xl 
                  hover:scale-[1.02] active:scale-95 transition-transform
                  cursor-pointer
                "
              >
                Kỉ niệm của chúng mình
              </button>
            </div>
          </motion.div>
        </div>
      </div>
      
      {showVideo && (
        <div className="fixed inset-0 bg-black/80 z-20 flex items-center justify-center p-4">
          <div className="bg-black rounded-3xl shadow-2xl">
            <video src="/clip.mp4" controls autoPlay className="h-full max-w-3xl max-h-[80vh]" />
            <button onClick={() => setShowVideo(false)} className="absolute top-4 right-4 bg-white/90 rounded-full p-2 shadow">✕</button>
          </div>
        </div>
      )}
      
      

      <style>{`
        .scene { perspective: 900px; }
        .envelope { width: 360px; max-width: 86vw; height: 500px; position: relative; transform-style: preserve-3d; transition: transform 0.5s ease; }
        .envelope-body { width: 100%; height: 100%; position: relative; border-radius: 12px; background: linear-gradient(180deg, #fff 0%, #fff6f8 100%); box-shadow: 0 12px 30px rgba(220,30,90,0.09), inset 0 -6px 18px rgba(0,0,0,0.03); transform-origin: top center; transition: transform 0.9s cubic-bezier(.2,.9,.3,1); }
        .envelope .shine { position:absolute; inset:0; pointer-events:none; background: linear-gradient(90deg, rgba(255,255,255,0.05), rgba(255,255,255,0)); border-radius:12px; }
        .envelope-flap { position:absolute; left:0; right:0; top:0; height:50%; background: linear-gradient(180deg,#ffefef,#ffdfe6); border-top-left-radius:12px; border-top-right-radius:12px; transform-origin: top center; transform: translateZ(1px) rotateX(0deg); transition: transform 0.9s cubic-bezier(.2,.9,.3,1); box-shadow: 0 10px 20px rgba(220,30,90,0.06); }
        .envelope-body.open .envelope-flap { transform: rotateX(180deg) translateY(-1px); border-top-left-radius:6px; border-top-right-radius:6px; }
        .letter { position: absolute; left: 8%; right: 8%; top: 10%; bottom: 8%; background: linear-gradient(180deg,#fff,#fffefc); border-radius:8px; box-shadow: inset 0 -6px 12px rgba(0,0,0,0.02); transform: translateZ(-6px) translateY(6px); opacity: 0; transition: opacity 0.6s 0.14s ease, transform 0.6s 0.14s cubic-bezier(.2,.9,.3,1); display:flex; align-items:center; justify-content:center; padding:22px; }
        .envelope-body.open .letter { opacity: 1; transform: translateZ(8px) translateY(0); }
        .letter-inner { text-align:left; color:#6b1027; }
      `}</style>
    </div>
  );
}
